﻿import { Dispatch } from 'redux';
import { TopOrderSystemAlertsRequest } from '../../model/reporting/topOrderSystemAlertsRequest';
import reportingService from '../../services/ReportingService';
import {
  CLEAR_REPORTING,
  FETCH_REPORTING_SYSTEM_ALERTS,
  FETCH_REPORTING_SYSTEM_ALERTS_FAILURE,
  FETCH_REPORTING_SYSTEM_ALERTS_SUCCESS,
} from '../constants';
import { ReportingActionTypes } from '../types/reportingActionTypes';

export function fetchReportingSystemAlerts(): ReportingActionTypes {
  return {
    type: FETCH_REPORTING_SYSTEM_ALERTS,
  };
}

export function fetchReportingSystemAlertsSuccess(data: any) {
  return {
    type: FETCH_REPORTING_SYSTEM_ALERTS_SUCCESS,
    payload: data,
  };
}

export function fetchComplianceOverviewError(
  error: string
): ReportingActionTypes {
  return {
    type: FETCH_REPORTING_SYSTEM_ALERTS_FAILURE,
    payload: error,
  };
}

export function getReportingSystemAlerts() {
  return async function action(dispatch: Dispatch<any>) {
    dispatch(fetchReportingSystemAlerts());
    //hardcode to top 100 alerts for now
    const request: TopOrderSystemAlertsRequest = {
      Top: 100,
    };

    return reportingService.getTopOrderSystemAlerts(request).then(
      (response: any) => {
        dispatch(fetchReportingSystemAlertsSuccess(response.items));
      }
      //error => dispatch(someerror('woody', buzz, error))
    );
  };
}

export function clearReportingData(): ReportingActionTypes {
  return {
    type: CLEAR_REPORTING,
  };
}
